// extracted by mini-css-extract-plugin
export var attribution = "_be-4";
export var authorName = "_be-5";
export var quote = "_be-3";
export var testimonial = "_be-2";
export var trustedBy = "_be-0";
export var trustedByLabel = "_be-1";